import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const VALUE_WIDTH = 125;

const Container = styled.div`
  display: flex;
  justify-content: center;
  min-width: ${VALUE_WIDTH*2}px;
`;

const ValueContainer = styled.div`
  margin: 8px 0px 0px 0px;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: ${VALUE_WIDTH}px;
`;

const CountWrapper = styled.span`
  font-size: 12px;
  line-height: 14px;
  margin: 0px 8px;
`;

const Marker = styled.div`
  height: 4px;
  min-width: 4px;
  background: #FF5630;
  border-radius: 3px 0px 0px 3px;
  margin-bottom: 4px;
`;

const DeactiveMarker = styled.div`
  height: 4px;
  min-width: 4px;
  background: #D8D8D8;
  border-radius: 0px 3px 3px 0px;
  margin-bottom: 4px;
`;

export const LeftHorizontalBarCell = ({maxValue, count}) => (
  <ValueContainer style={{alignItems: 'flex-end'}}>
    <Marker style={{width: VALUE_WIDTH * count / maxValue}} />
    <CountWrapper>{count}</CountWrapper>
  </ValueContainer>
)

export const RightHorizontalBarCell = ({maxValue, count}) => (
  <ValueContainer>
    <DeactiveMarker style={{width: VALUE_WIDTH * count / maxValue}} />
    <CountWrapper>{count}</CountWrapper>
  </ValueContainer>
)

export default class HorizontalBarCell extends PureComponent {
  static propTypes = {
    maxValue: PropTypes.number,
    activated: PropTypes.number,
    deactivated: PropTypes.number,
  };
    
  render() {
    const {maxValue, activated, deactivated} = this.props;
    const mValue = maxValue ? maxValue : VALUE_WIDTH;

    return (
      <Container>
        <LeftHorizontalBarCell maxValue={mValue} count={activated} />
        <RightHorizontalBarCell maxValue={mValue} count={deactivated} />
      </Container>
    );
  }
}
